<div class="flex h-full w-full flex-col gap-3 overflow-auto p-2">
  @if (viewMode() === 'dossier') {
    <!-- Dossier View Mode -->
    <div class="flex flex-col gap-2">
      @if (dossierForUpdate()?.files && dossierForUpdate()!.files!.length > 0) {
        @for (file of dossierForUpdate()!.files!; track file.sha256) {
          <ng-container
            *ngTemplateOutlet="
              fileRowTemplate;
              context: { file: file, showBackArrow: true }
            "
          ></ng-container>
        }
      } @else {
        <div class="surface-low flex items-center gap-2 rounded-md p-2">
          <span class="text-sm">Nessun file nel dossier</span>
        </div>
      }
    </div>
  } @else if (isLoading()) {
    <div class="flex h-full items-center justify-center">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  } @else if (totalItems() === 0) {
    <div class="text-outline flex h-full items-center justify-center">
      <span class="text-sm">Nessun file correlato</span>
    </div>
  } @else {
    <div class="flex flex-col gap-3">
      @for (
        rowStart of [].constructor(rowCount());
        track $index;
        let rowIndex = $index
      ) {
        @let rowStartIdx = rowIndex * columnsCount();
        <div class="flex flex-col gap-3">
          <div
            class="grid gap-3"
            [class.grid-cols-3]="isMobile()"
            [class.grid-cols-5]="!isMobile()"
          >
            @for (
              itemIdx of [].constructor(columnsCount());
              track $index;
              let colIndex = $index
            ) {
              @let globalIdx = rowStartIdx + colIndex;
              @if (globalIdx < totalItems()) {
                @if (globalIdx === 0 && hasSameFolder()) {
                  <ng-container
                    *ngTemplateOutlet="
                      folderTemplate;
                      context: {
                        isSelected: isSameFolderSelected(),
                        name: 'Stessa cartella' | siaTranslate,
                        showMenu: false,
                        onClick: toggleSameFolder.bind(this),
                      }
                    "
                  ></ng-container>
                } @else {
                  @let dossierIdx = hasSameFolder() ? globalIdx - 1 : globalIdx;
                  @let dossier = dossiers()[dossierIdx];
                  @if (dossier) {
                    <ng-container
                      *ngTemplateOutlet="
                        folderTemplate;
                        context: {
                          isSelected: selectedFolderId() === dossier.id,
                          name: dossier.name,
                          showMenu: true,
                          dossierId: dossier.id,
                          onClick: toggleDossier.bind(this, dossier.id!),
                        }
                      "
                    ></ng-container>
                  }
                }
              }
            }
            @if (rowIndex === rowCount() - 1) {
              <ng-container
                *ngTemplateOutlet="
                  folderTemplate;
                  context: {
                    specialFolder: true,
                  }
                "
              ></ng-container>
            }
          </div>

          @if (shouldShowExpandedPanelAfterRow(rowStartIdx)) {
            <ng-container
              *ngTemplateOutlet="expandedPanelTemplate"
            ></ng-container>
          }
        </div>
      }
    </div>
  }
</div>

<!-- Folder Template -->
<ng-template
  #folderTemplate
  let-isSelected="isSelected"
  let-name="name"
  let-showMenu="showMenu"
  let-dossierId="dossierId"
  let-onClick="onClick"
  let-specialFolder="specialFolder"
>
  @if (!specialFolder) {
    <div
      class="relative flex cursor-pointer flex-col items-center rounded-lg p-3 transition-all"
      [class.surface-low]="!isSelected"
      [class.bg-primary-container]="isSelected"
      [class.rounded-b-none]="isSelected"
      [class.mb-[-20px]]="isSelected"
      [class.pb-8]="isSelected"
      [class.z-10]="isSelected"
      (click)="onClick()"
    >
      @if (showMenu) {
        <ng-container
          *ngTemplateOutlet="
            folderMenuTemplate;
            context: { dossierId: dossierId }
          "
        ></ng-container>
      }

      <mat-icon
        class="mb-2 !h-fit !w-fit !text-3xl md:mb-4 md:!text-5xl"
        [class.text-tertiary]="!isSelected"
        [class.text-primary]="isSelected"
      >
        {{ isSelected ? 'folder_open' : 'folder' }}
      </mat-icon>

      <span
        class="w-full truncate text-center text-xs font-medium"
        [title]="name"
      >
        {{ name }}
      </span>
    </div>
  } @else {
    <div
      class="surface-low relative flex !hidden cursor-pointer flex-col items-center rounded-lg p-3 transition-all"
      (click)="createDossier()"
    >
      <mat-icon
        class="mb-2 !h-fit !w-fit !text-3xl md:mb-4 md:!text-5xl"
        [class.text-tertiary]="!isSelected"
        [class.text-primary]="isSelected"
      >
        create_new_folder
      </mat-icon>

      <span
        class="w-full truncate text-center text-xs font-medium"
        title="Aggiungi fascicolo"
      >
        {{ 'Aggiungi fascicolo' | siaTranslate }}
      </span>
    </div>
  }
</ng-template>

<!-- Folder Menu Template -->
<ng-template #folderMenuTemplate let-dossierId="dossierId">
  <div class="absolute right-1 top-1">
    <button
      mat-icon-button
      [matMenuTriggerFor]="folderMenu"
      class="!h-8 !w-8"
      (click)="$event.stopPropagation()"
    >
      <mat-icon class="!text-lg">more_vert</mat-icon>
    </button>
    <mat-menu #folderMenu="matMenu">
      <button mat-menu-item (click)="updateDossier(dossierId)">
        <mat-icon>edit</mat-icon>
        <span>{{ 'Modifica' | siaTranslate }}</span>
      </button>
      <button mat-menu-item (click)="deleteDossier(dossierId)">
        <mat-icon class="text-error">delete</mat-icon>
        <span>{{ 'Elimina' | siaTranslate }}</span>
      </button>
    </mat-menu>
  </div>
</ng-template>

<!-- Expanded Panel Template -->
<ng-template #expandedPanelTemplate>
  <div class="bg-primary-container w-full rounded-lg p-4">
    <div class="flex flex-col gap-2">
      @if (getSelectedFiles().length > 0) {
        @for (file of getSelectedFiles(); track file.sha256) {
          <ng-container
            *ngTemplateOutlet="fileRowTemplate; context: { file: file }"
          ></ng-container>
        }
      } @else {
        <span class="text-sm font-medium">Nessun file</span>
      }
    </div>
  </div>
</ng-template>

<!-- File Row Template -->
<ng-template #fileRowTemplate let-file="file" let-showBackArrow="showBackArrow">
  <div
    class="surface-low sia-hover flex items-center gap-2 rounded-md p-2"
    [ngClass]="{
      'slide-in-from-left': file._isAnimatingIn || isAnimatingIn(file.sha256),
      'slide-out-left': isAnimatingOut(file.sha256),
    }"
    (click)="selectDossierFile(file)"
  >
    @if (showBackArrow) {
      <button
        mat-icon-button
        class="!h-8 !w-8"
        (click)="removeFilesFromDossier(file)"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>
    }
    <mat-icon class="text-base" [style.color]="file.color">
      {{ file.icon }}
    </mat-icon>
    <span class="flex-1 truncate text-sm font-medium" [title]="file.name">
      {{ file.name }}
    </span>
  </div>
</ng-template>
